import { render, staticRenderFns } from "./EditLocation.vue?vue&type=template&id=3aae38db&"
import script from "./EditLocation.vue?vue&type=script&lang=ts&"
export * from "./EditLocation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports